import { createContext, useContext, ReactNode } from "react"
import { CorrespondenceContextValue } from "../types/correspondence"

const CorrespondenceContext = createContext<CorrespondenceContextValue | null>(
  null,
)

export function useCorrespondenceContext() {
  const context = useContext(CorrespondenceContext)
  if (!context) {
    throw new Error(
      "useCorrespondenceContext must be used within CorrespondenceProvider",
    )
  }

  return context
}

export interface CorrespondenceProviderProps extends CorrespondenceContextValue {
  children: ReactNode
}

export function CorrespondenceProvider({
  children,
  entityType,
  entityId,
  entityName,
  createCorrespondenceThreadMutation,
  handleNavigateToThread,
  contextType,
  loadEntityOptions,
  canCreateCorrespondence,
  correspondenceCreatePermissions,
  correspondencePermission,
}: CorrespondenceProviderProps) {
  const isCorrespondenceInbox = contextType === "inbox"
  const isStudentInbox = contextType === "student-inbox"

  return (
    <CorrespondenceContext.Provider
      value={{
        createCorrespondenceThreadMutation,
        handleNavigateToThread,
        entityType,
        entityId,
        entityName,
        isCorrespondenceInbox,
        isStudentInbox,
        loadEntityOptions,
        canCreateCorrespondence,
        correspondenceCreatePermissions,
        correspondencePermission,
      }}
    >
      {children}
    </CorrespondenceContext.Provider>
  )
}
